export enum DomainLocale {
  EN = 'en',
  NL = 'nl',
}

export const DEFAULT_LOCALE = DomainLocale.EN;
